import React, { Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import 'shared/styles/modern-theme.css';

import PageLoader from 'shared/components/PageLoader';
import NewVersionPrompt from 'shared/components/NewVersionPrompt';
import { LanguageProvider, useLanguage } from 'shared/context/LanguageContext';
import { CourierOnboardingPage } from 'features/courier-onboarding';
//iss
import {
  CourierAuthProvider,
  CourierLoginPage,
  CourierProtectedRoute,
} from 'features/courier-auth';
import { CourierPortalPage } from 'features/courier-portal';
import { CourierTrainingPage } from 'features/courier-training';
import { CourierStorePage } from 'features/courier-store';
import { WelcomePage } from 'features/welcome';
import ErrorBoundary from 'app/ErrorBoundary';

const ToastBridge: React.FC = () => {
  const { dir } = useLanguage();
  return (
    <ToastContainer
      position="top-center"
      autoClose={2500}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      rtl={dir === 'rtl'}
      style={{ zIndex: 99999 }}
    />
  );
};

const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <LanguageProvider>
          <CourierAuthProvider>
            <Suspense fallback={<PageLoader />}>
              <Routes>
                <Route path="/" element={<WelcomePage />} />
                <Route path="/onboarding" element={<CourierOnboardingPage />} />
                <Route path="/login" element={<CourierLoginPage />} />
                <Route element={<CourierProtectedRoute />}>
                  <Route path="/portal" element={<CourierPortalPage />} />
                  <Route path="/portal/training" element={<CourierTrainingPage />} />
                  <Route path="/portal/store" element={<CourierStorePage />} />
                </Route>
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Suspense>
            <ToastBridge />
            <NewVersionPrompt />
          </CourierAuthProvider>
        </LanguageProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
};

export default App;
